/**
 * Helper function for providing a tag list for 'get' requests.  To be used when calling a full list like getRanches and getScans but not individual fetches like getRanch.
 * @param resultsWithIds
 * @param tagType
 * @returns
 */
export function providesList<
  R extends { id: string | number }[],
  T extends string
>(resultsWithIds: R | undefined, tagType: T) {
  return [
    { type: tagType, id: 'LIST' },
    ...(resultsWithIds
      ? resultsWithIds.map(({ id }) => ({ type: tagType, id }))
      : []),
  ];
}
